import { PlayerColor } from '@colonist/game-states';
import RoadRed from '@static/images/road_red.svg';
import RoadBlue from '@static/images/road_blue.svg';
import RoadOrange from '@static/images/road_orange.svg';
import RoadGreen from '@static/images/road_green.svg';
import RoadBlack from '@static/images/road_black.svg';
import RoadBronze from '@static/images/road_bronze.svg';
import RoadSilver from '@static/images/road_silver.svg';
import RoadGold from '@static/images/road_gold.svg';
import RoadWhite from '@static/images/road_white.svg';
import RoadPurple from '@static/images/road_purple.svg';
import RoadMysticBlue from '@static/images/road_mysticblue.svg';
import RoadPink from '@static/images/road_pink.svg';
import SettlementRed from '@static/images/settlement_red.svg';
import SettlementBlue from '@static/images/settlement_blue.svg';
import SettlementOrange from '@static/images/settlement_orange.svg';
import SettlementGreen from '@static/images/settlement_green.svg';
import SettlementBlack from '@static/images/settlement_black.svg';
import SettlementBronze from '@static/images/settlement_bronze.svg';
import SettlementSilver from '@static/images/settlement_silver.svg';
import SettlementGold from '@static/images/settlement_gold.svg';
import SettlementWhite from '@static/images/settlement_white.svg';
import SettlementPurple from '@static/images/settlement_purple.svg';
import SettlementMysticBlue from '@static/images/settlement_mysticblue.svg';
import SettlementPink from '@static/images/settlement_pink.svg';
import CityRed from '@static/images/city_red.svg';
import CityBlue from '@static/images/city_blue.svg';
import CityOrange from '@static/images/city_orange.svg';
import CityGreen from '@static/images/city_green.svg';
import CityBlack from '@static/images/city_black.svg';
import CityBronze from '@static/images/city_bronze.svg';
import CitySilver from '@static/images/city_silver.svg';
import CityGold from '@static/images/city_gold.svg';
import CityWhite from '@static/images/city_white.svg';
import CityPurple from '@static/images/city_purple.svg';
import CityMysticBlue from '@static/images/city_mysticblue.svg';
import CityPink from '@static/images/city_pink.svg';
import CityWallRed from '@static/images/city_wall_red.svg';
import CityWallBlue from '@static/images/city_wall_blue.svg';
import CityWallOrange from '@static/images/city_wall_orange.svg';
import CityWallGreen from '@static/images/city_wall_green.svg';
import CityWallBlack from '@static/images/city_wall_black.svg';
import CityWallBronze from '@static/images/city_wall_bronze.svg';
import CityWallSilver from '@static/images/city_wall_silver.svg';
import CityWallGold from '@static/images/city_wall_gold.svg';
import CityWallWhite from '@static/images/city_wall_white.svg';
import CityWallPurple from '@static/images/city_wall_purple.svg';
import CityWallMysticBlue from '@static/images/city_wall_mysticblue.svg';
import CityWallPink from '@static/images/city_wall_pink.svg';
import ShipRedNorthWest from '@static/images/ship_red_north_west.svg';
import ShipBlueNorthWest from '@static/images/ship_blue_north_west.svg';
import ShipOrangeNorthWest from '@static/images/ship_orange_north_west.svg';
import ShipGreenNorthWest from '@static/images/ship_green_north_west.svg';
import ShipBlackNorthWest from '@static/images/ship_black_north_west.svg';
import ShipBronzeNorthWest from '@static/images/ship_bronze_north_west.svg';
import ShipSilverNorthWest from '@static/images/ship_silver_north_west.svg';
import ShipGoldNorthWest from '@static/images/ship_gold_north_west.svg';
import ShipWhiteNorthWest from '@static/images/ship_white_north_west.svg';
import ShipPurpleNorthWest from '@static/images/ship_purple_north_west.svg';
import ShipMysticBlueNorthWest from '@static/images/ship_mysticblue_north_west.svg';
import ShipPinkNorthWest from '@static/images/ship_pink_north_west.svg';
import ShipMoveRed from '@static/images/ship_move_red.svg';
import ShipMoveBlue from '@static/images/ship_move_blue.svg';
import ShipMoveOrange from '@static/images/ship_move_orange.svg';
import ShipMoveGreen from '@static/images/ship_move_green.svg';
import ShipMoveBlack from '@static/images/ship_move_black.svg';
import ShipMoveBronze from '@static/images/ship_move_bronze.svg';
import ShipMoveSilver from '@static/images/ship_move_silver.svg';
import ShipMoveGold from '@static/images/ship_move_gold.svg';
import ShipMoveWhite from '@static/images/ship_move_white.svg';
import ShipMovePurple from '@static/images/ship_move_purple.svg';
import ShipMoveMysticBlue from '@static/images/ship_move_mysticblue.svg';
import ShipMovePink from '@static/images/ship_move_pink.svg';
import KnightLevel1InactiveRed from '@static/images/knight_level1_inactive_red.svg';
import KnightLevel1InactiveBlue from '@static/images/knight_level1_inactive_blue.svg';
import KnightLevel1InactiveOrange from '@static/images/knight_level1_inactive_orange.svg';
import KnightLevel1InactiveGreen from '@static/images/knight_level1_inactive_green.svg';
import KnightLevel1InactiveBlack from '@static/images/knight_level1_inactive_black.svg';
import KnightLevel1InactiveBronze from '@static/images/knight_level1_inactive_bronze.svg';
import KnightLevel1InactiveSilver from '@static/images/knight_level1_inactive_silver.svg';
import KnightLevel1InactiveGold from '@static/images/knight_level1_inactive_gold.svg';
import KnightLevel1InactiveWhite from '@static/images/knight_level1_inactive_white.svg';
import KnightLevel1InactivePurple from '@static/images/knight_level1_inactive_purple.svg';
import KnightLevel1InactiveMysticBlue from '@static/images/knight_level1_inactive_mysticblue.svg';
import KnightLevel1InactivePink from '@static/images/knight_level1_inactive_pink.svg';
import KnightLevel1ActiveRed from '@static/images/knight_level1_active_red.svg';
import KnightLevel1ActiveBlue from '@static/images/knight_level1_active_blue.svg';
import KnightLevel1ActiveOrange from '@static/images/knight_level1_active_orange.svg';
import KnightLevel1ActiveGreen from '@static/images/knight_level1_active_green.svg';
import KnightLevel1ActiveBlack from '@static/images/knight_level1_active_black.svg';
import KnightLevel1ActiveBronze from '@static/images/knight_level1_active_bronze.svg';
import KnightLevel1ActiveSilver from '@static/images/knight_level1_active_silver.svg';
import KnightLevel1ActiveGold from '@static/images/knight_level1_active_gold.svg';
import KnightLevel1ActiveWhite from '@static/images/knight_level1_active_white.svg';
import KnightLevel1ActivePurple from '@static/images/knight_level1_active_purple.svg';
import KnightLevel1ActiveMysticBlue from '@static/images/knight_level1_active_mysticblue.svg';
import KnightLevel1ActivePink from '@static/images/knight_level1_active_pink.svg';
import KnightMoveRed from '@static/images/knight_move_red.svg';
import KnightMoveBlue from '@static/images/knight_move_blue.svg';
import KnightMoveOrange from '@static/images/knight_move_orange.svg';
import KnightMoveGreen from '@static/images/knight_move_green.svg';
import KnightMoveBlack from '@static/images/knight_move_black.svg';
import KnightMoveBronze from '@static/images/knight_move_bronze.svg';
import KnightMoveSilver from '@static/images/knight_move_silver.svg';
import KnightMoveGold from '@static/images/knight_move_gold.svg';
import KnightMoveWhite from '@static/images/knight_move_white.svg';
import KnightMovePurple from '@static/images/knight_move_purple.svg';
import KnightMoveMysticBlue from '@static/images/knight_move_mysticblue.svg';
import KnightMovePink from '@static/images/knight_move_pink.svg';
import IconMerchantRed from '@static/images/icon_merchant_red.svg';
import IconMerchantBlue from '@static/images/icon_merchant_blue.svg';
import IconMerchantOrange from '@static/images/icon_merchant_orange.svg';
import IconMerchantGreen from '@static/images/icon_merchant_green.svg';
import IconMerchantBlack from '@static/images/icon_merchant_black.svg';
import IconMerchantBronze from '@static/images/icon_merchant_bronze.svg';
import IconMerchantSilver from '@static/images/icon_merchant_silver.svg';
import IconMerchantGold from '@static/images/icon_merchant_gold.svg';
import IconMerchantWhite from '@static/images/icon_merchant_white.svg';
import IconMerchantPurple from '@static/images/icon_merchant_purple.svg';
import IconMerchantMysticBlue from '@static/images/icon_merchant_mysticblue.svg';
import IconMerchantPink from '@static/images/icon_merchant_pink.svg';
export const ROAD_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: RoadRed,
    [PlayerColor.Blue]: RoadBlue,
    [PlayerColor.Orange]: RoadOrange,
    [PlayerColor.Green]: RoadGreen,
    [PlayerColor.Black]: RoadBlack,
    [PlayerColor.Bronze]: RoadBronze,
    [PlayerColor.Silver]: RoadSilver,
    [PlayerColor.Gold]: RoadGold,
    [PlayerColor.White]: RoadWhite,
    [PlayerColor.Purple]: RoadPurple,
    [PlayerColor.MysticBlue]: RoadMysticBlue,
    [PlayerColor.Pink]: RoadPink
};
export const SETTLEMENT_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: SettlementRed,
    [PlayerColor.Blue]: SettlementBlue,
    [PlayerColor.Orange]: SettlementOrange,
    [PlayerColor.Green]: SettlementGreen,
    [PlayerColor.Black]: SettlementBlack,
    [PlayerColor.Bronze]: SettlementBronze,
    [PlayerColor.Silver]: SettlementSilver,
    [PlayerColor.Gold]: SettlementGold,
    [PlayerColor.White]: SettlementWhite,
    [PlayerColor.Purple]: SettlementPurple,
    [PlayerColor.MysticBlue]: SettlementMysticBlue,
    [PlayerColor.Pink]: SettlementPink
};
export const CITY_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: CityRed,
    [PlayerColor.Blue]: CityBlue,
    [PlayerColor.Orange]: CityOrange,
    [PlayerColor.Green]: CityGreen,
    [PlayerColor.Black]: CityBlack,
    [PlayerColor.Bronze]: CityBronze,
    [PlayerColor.Silver]: CitySilver,
    [PlayerColor.Gold]: CityGold,
    [PlayerColor.White]: CityWhite,
    [PlayerColor.Purple]: CityPurple,
    [PlayerColor.MysticBlue]: CityMysticBlue,
    [PlayerColor.Pink]: CityPink
};
export const CITY_WALL_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: CityWallRed,
    [PlayerColor.Blue]: CityWallBlue,
    [PlayerColor.Orange]: CityWallOrange,
    [PlayerColor.Green]: CityWallGreen,
    [PlayerColor.Black]: CityWallBlack,
    [PlayerColor.Bronze]: CityWallBronze,
    [PlayerColor.Silver]: CityWallSilver,
    [PlayerColor.Gold]: CityWallGold,
    [PlayerColor.White]: CityWallWhite,
    [PlayerColor.Purple]: CityWallPurple,
    [PlayerColor.MysticBlue]: CityWallMysticBlue,
    [PlayerColor.Pink]: CityWallPink
};
export const SHIP_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: ShipRedNorthWest,
    [PlayerColor.Blue]: ShipBlueNorthWest,
    [PlayerColor.Orange]: ShipOrangeNorthWest,
    [PlayerColor.Green]: ShipGreenNorthWest,
    [PlayerColor.Black]: ShipBlackNorthWest,
    [PlayerColor.Bronze]: ShipBronzeNorthWest,
    [PlayerColor.Silver]: ShipSilverNorthWest,
    [PlayerColor.Gold]: ShipGoldNorthWest,
    [PlayerColor.White]: ShipWhiteNorthWest,
    [PlayerColor.Purple]: ShipPurpleNorthWest,
    [PlayerColor.MysticBlue]: ShipMysticBlueNorthWest,
    [PlayerColor.Pink]: ShipPinkNorthWest
};
export const SHIP_MOVE_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: ShipMoveRed,
    [PlayerColor.Blue]: ShipMoveBlue,
    [PlayerColor.Orange]: ShipMoveOrange,
    [PlayerColor.Green]: ShipMoveGreen,
    [PlayerColor.Black]: ShipMoveBlack,
    [PlayerColor.Bronze]: ShipMoveBronze,
    [PlayerColor.Silver]: ShipMoveSilver,
    [PlayerColor.Gold]: ShipMoveGold,
    [PlayerColor.White]: ShipMoveWhite,
    [PlayerColor.Purple]: ShipMovePurple,
    [PlayerColor.MysticBlue]: ShipMoveMysticBlue,
    [PlayerColor.Pink]: ShipMovePink
};
export const KNIGHT_LEVEL1_INACTIVE_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: KnightLevel1InactiveRed,
    [PlayerColor.Blue]: KnightLevel1InactiveBlue,
    [PlayerColor.Orange]: KnightLevel1InactiveOrange,
    [PlayerColor.Green]: KnightLevel1InactiveGreen,
    [PlayerColor.Black]: KnightLevel1InactiveBlack,
    [PlayerColor.Bronze]: KnightLevel1InactiveBronze,
    [PlayerColor.Silver]: KnightLevel1InactiveSilver,
    [PlayerColor.Gold]: KnightLevel1InactiveGold,
    [PlayerColor.White]: KnightLevel1InactiveWhite,
    [PlayerColor.Purple]: KnightLevel1InactivePurple,
    [PlayerColor.MysticBlue]: KnightLevel1InactiveMysticBlue,
    [PlayerColor.Pink]: KnightLevel1InactivePink
};
export const KNIGHT_ACTIVATION_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: KnightLevel1ActiveRed,
    [PlayerColor.Blue]: KnightLevel1ActiveBlue,
    [PlayerColor.Orange]: KnightLevel1ActiveOrange,
    [PlayerColor.Green]: KnightLevel1ActiveGreen,
    [PlayerColor.Black]: KnightLevel1ActiveBlack,
    [PlayerColor.Bronze]: KnightLevel1ActiveBronze,
    [PlayerColor.Silver]: KnightLevel1ActiveSilver,
    [PlayerColor.Gold]: KnightLevel1ActiveGold,
    [PlayerColor.White]: KnightLevel1ActiveWhite,
    [PlayerColor.Purple]: KnightLevel1ActivePurple,
    [PlayerColor.MysticBlue]: KnightLevel1ActiveMysticBlue,
    [PlayerColor.Pink]: KnightLevel1ActivePink
};
export const KNIGHT_MOVE_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: KnightMoveRed,
    [PlayerColor.Blue]: KnightMoveBlue,
    [PlayerColor.Orange]: KnightMoveOrange,
    [PlayerColor.Green]: KnightMoveGreen,
    [PlayerColor.Black]: KnightMoveBlack,
    [PlayerColor.Bronze]: KnightMoveBronze,
    [PlayerColor.Silver]: KnightMoveSilver,
    [PlayerColor.Gold]: KnightMoveGold,
    [PlayerColor.White]: KnightMoveWhite,
    [PlayerColor.Purple]: KnightMovePurple,
    [PlayerColor.MysticBlue]: KnightMoveMysticBlue,
    [PlayerColor.Pink]: KnightMovePink
};
export const KNIGHT_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: KnightLevel1InactiveRed,
    [PlayerColor.Blue]: KnightLevel1InactiveBlue,
    [PlayerColor.Orange]: KnightLevel1InactiveOrange,
    [PlayerColor.Green]: KnightLevel1InactiveGreen,
    [PlayerColor.Black]: KnightLevel1InactiveBlack,
    [PlayerColor.Bronze]: KnightLevel1InactiveBronze,
    [PlayerColor.Silver]: KnightLevel1InactiveSilver,
    [PlayerColor.Gold]: KnightLevel1InactiveGold,
    [PlayerColor.White]: KnightLevel1InactiveWhite,
    [PlayerColor.Purple]: KnightLevel1InactivePurple,
    [PlayerColor.MysticBlue]: KnightLevel1InactiveMysticBlue,
    [PlayerColor.Pink]: KnightLevel1InactivePink
};
export const MERCHANT_IMAGE_PATH = {
    [PlayerColor.None]: '',
    [PlayerColor.Red]: IconMerchantRed,
    [PlayerColor.Blue]: IconMerchantBlue,
    [PlayerColor.Orange]: IconMerchantOrange,
    [PlayerColor.Green]: IconMerchantGreen,
    [PlayerColor.Black]: IconMerchantBlack,
    [PlayerColor.Bronze]: IconMerchantBronze,
    [PlayerColor.Silver]: IconMerchantSilver,
    [PlayerColor.Gold]: IconMerchantGold,
    [PlayerColor.White]: IconMerchantWhite,
    [PlayerColor.Purple]: IconMerchantPurple,
    [PlayerColor.MysticBlue]: IconMerchantMysticBlue,
    [PlayerColor.Pink]: IconMerchantPink
};
